var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00854492H513V341.995H0V-0.00854492Z",
    fill: "#91DC5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00854492H513V341.995H0V-0.00854492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00854492H513V57.2911H0V-0.00854492ZM0 284.695H513V341.984H0V284.695Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.0315H513V261.968H0V80.0315Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.702 236.784C227.04 236.784 256.498 207.326 256.498 170.988C256.498 134.649 227.04 105.191 190.702 105.191C154.363 105.191 124.905 134.649 124.905 170.988C124.905 207.326 154.363 236.784 190.702 236.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.704 105.198L205.467 150.632H253.317L214.592 178.715L229.47 224.285L190.704 196.07L151.998 224.232L166.816 178.715L128.125 150.632H175.94L190.704 105.198Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0065918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKp);
export default __webpack_public_path__ + "static/media/KP.233c4c36fd0e8e790de7c68af2adc13f.svg";
export { ForwardRef as ReactComponent };